import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UserPermission } from 'src/app/enums/enums';
import { PermissionService } from 'src/app/services/app/permission-access-service/permissionBased.service';

@Component({
  selector: 'app-trip-action-dropdown',
  templateUrl: './trip-action-dropdown.component.html',
  styleUrls: ['./trip-action-dropdown.component.css']
})
export class TripActionDropdownComponent {
  userPermission = UserPermission;
  
  constructor(
    public permissionService: PermissionService,
  ) { }
  
  @Input() trip: any;
  @Input() source: any
  @Output() assign = new EventEmitter<any>();
  @Output() edit = new EventEmitter<any>();
  @Output() detail = new EventEmitter<any>();
  @Output() cancel = new EventEmitter<any>();
  @Output() notes = new EventEmitter<any>();
  @Output() sendtoMarketplace = new EventEmitter<any>();
  @Output() getBackFromMarketplace = new EventEmitter<any>();
  @Output() getBackFromArchive = new EventEmitter<any>();
  @Output() autoDistribute = new EventEmitter<any>();
  @Output() adjustTrip = new EventEmitter<any>();
  @Output() adjustFundingSourceTrip = new EventEmitter<any>();
  @Output() tripTrails = new EventEmitter<any>();
  @Output() reroute = new EventEmitter<any>();
  @Output() archive = new EventEmitter<any>();
  @Output() invoiceModal = new EventEmitter<any>();
  @Input() canPay = false;
  @Output() pay = new EventEmitter<any>();



  @Output() markReady = new EventEmitter<any>();
  @Output() markVip = new EventEmitter<any>();
  @Output() notAnswer = new EventEmitter<any>();
  @Output() badPhoneNumber = new EventEmitter<any>();
  @Output() markConfirmed = new EventEmitter<any>();
  @Output() markVoicemail = new EventEmitter<any>();
  @Output() markMultiload = new EventEmitter<any>();
  @Output() markDeadMiles = new EventEmitter<any>();
  @Output() markMethadone = new EventEmitter<any>();
  @Output() markEstimation = new EventEmitter<any>();
  @Output() clone = new EventEmitter<any>();
  @Output() logs = new EventEmitter<any>();
  @Output() relationLeg = new EventEmitter<any>();
  @Output() approveBillingTrip = new EventEmitter<any>();
  @Output() rejectBillingTrip = new EventEmitter<any>();
  @Output() billableTrip = new EventEmitter<any>();
  @Output() signature = new EventEmitter<any>();
  @Output() willCallActivated = new EventEmitter<any>();
  @Output() unMarkWillCallActivated = new EventEmitter<any>();
  @Output() willCall = new EventEmitter<any>();
  @Output() sendToScheduled = new EventEmitter<any>();
  @Output() rejectPendingTrip = new EventEmitter<any>();
  @Output() markNoShow = new EventEmitter<any>();
  @Output() markComplete = new EventEmitter<any>();
  @Output() markCancel = new EventEmitter<any>();
  @Output() chargePayment = new EventEmitter<any>();
  @Output() generatePaymentLink = new EventEmitter<any>();
  @Output() updatePayment = new EventEmitter<any>();
  @Output() refund = new EventEmitter<any>();
  @Output() form837 = new EventEmitter<any>();
  @Output() raiseTicket = new EventEmitter<any>();

}
